import { Col, Row } from "antd";
import i18n from "i18next";
import { InputHTMLAttributes, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StateManagerProps } from "react-select/dist/declarations/src/stateManager";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { setFilterField } from "../../app/store/reducers/appSlice";
import { FilterButton, FilterButtonsContainer, FilterContainer, FilterInput, FilterLabel, FilterSelect } from "./styles";

interface FilterProps {
  onFilter: () => void;
  onClear: () => void;
}

export default function Filter({ onFilter, onClear }: FilterProps) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { activities, categories, countries, filter } = useAppSelector(store => store.AppSlice)

  const handleInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.currentTarget
    dispatch(setFilterField({ name, value }))
  }

  const defaultDropdownProps = useMemo((): StateManagerProps => ({
    isMulti: true,
    isClearable: true,
    isSearchable: true,
    closeMenuOnSelect: false,
    //@ts-ignore
    onChange: (value, { name }) => dispatch(setFilterField({ name, value })),
    getOptionLabel: (option: any) => option[i18n.language === "ru" ? "titleRu" : "titleEn"]
  }), [dispatch])

  const defaultInputProps = useMemo((): InputHTMLAttributes<HTMLInputElement> => ({
    type: "text",
    onChange: handleInputChange
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [])

  return (
    <FilterContainer>
      <Row gutter={15} style={{ marginBottom: 12 }}>
        <Col xs={24} sm={12}>
          <FilterLabel children={t("CompanyName")} />
          <FilterInput {...defaultInputProps} value={filter.name} name="name" />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <FilterLabel children={t("Stand")} />
          <FilterInput {...defaultInputProps} value={filter.stend} name="stend" />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <FilterLabel children={t("Country")} />
          <FilterSelect
            {...defaultDropdownProps}
            name="country"
            placeholder={t("SelectCountry")}
            value={filter.country}
            isMulti={false}
            closeMenuOnSelect={true}
            options={countries}
          />
        </Col>
        <Col xs={24} sm={12}>
          <FilterLabel children={t("Sector")} />
          <FilterSelect
            {...defaultDropdownProps}
            name="category"
            placeholder={t("SelectSector")}
            value={filter.category}
            options={categories}
          />
        </Col>
        <Col xs={24} sm={12}>
          <FilterLabel children={t("Activities")} />
          <FilterSelect
            {...defaultDropdownProps}
            name="activity"
            placeholder={t("SelectActivities")}
            value={filter.activity}
            options={activities}
            formatGroupLabel={defaultDropdownProps.getOptionLabel}
          />
        </Col>
      </Row>

      <FilterButtonsContainer>
        <FilterButton children={t("Find")} onClick={onFilter} style={{ marginLeft: 0 }} />
        <FilterButton outline children={t("Reset")} onClick={onClear} />
      </FilterButtonsContainer>

    </FilterContainer>
  )
}
